import './DaoFinancial.css'

interface Props {
  children?: React.ReactNode
}

function DaoFinancial({ children }: Props) {
  return <div className="DaoFinancial">{children}</div>
}

export default DaoFinancial
